export const MULTIPLIER = 0.09290304;
export const BASE_URL_SANCTUM = '/sanctum/csrf-cookie/';
export const BASE_URL_API = process.env.MIX_BUYDUBAI_API_URL;
export const DEFAULT_ENTRY_FIELDS =
  'fields=id,property_price,title,project_completed,url,project_completion_year,hero_image,price_from,short_description,available_usable_area,house_equipment,gps_latitude,gps_longitude,locations,available_disposition,slug,fully_booked,occupancy,score';
export const RECAPTCHA_SITE_KEY = process.env.MIX_RECAPTCHA_SITE_KEY;
export const RENT = 'rent';
